<template>


    <a class="big upper connect-wallet with-balance small button" disabled="false" variant="secondary">
    <div style="position: relative;">
        {{ text }}
        <svg viewBox="0 0 89 37" class="shadow" style="transform: rotate(-2.34828deg) scale(1.15);">
            <path d="M21.570055047739594 5.575521391049077L87.89782636825738 5.129389249598496L78.31952650682192 32.87969249899542L9.35963422650482 27.78999224468555L21.570055047739594 5.575521391049077Z" style="fill: #0062F9;"></path>
        </svg>
        <svg viewBox="0 0 89 37" style="transform: rotate(-2.34828deg) scale(1.15);">
            <path d="M21.570055047739594 5.575521391049077L87.89782636825738 5.129389249598496L78.31952650682192 32.87969249899542L9.35963422650482 27.78999224468555L21.570055047739594 5.575521391049077Z" style="fill: #FF04B4;"></path>
        </svg>
    </div>
    </a>

</template>

<script>
export default {
  name: 'PunkButton',
  props: {
    text: String
  }
}
</script>

<style scoped>
:root {
    --gray-50: #F9FAFB;
    --gray-100: #F3F4F6;
    --gray-200: #E5E7EB;
    --gray-300: #D1D5DB;
    --gray-400: #9CA3AF;
    --gray-500: #6B7280;
    --gray-600: #4B5563;
    --gray-700: #374151;
    --gray-800: #232B37;
    --gray-900: #16191E;
    --white: #FFFFFF;
    --gray: var(--gray-400);
    --black: #000000;
    --primary: #FF04B4;
    --primary-dark: #1D1B28;
    --contrast: #0062F9;
    --danger: #EF4444;
    --red: #F87171;
    --semi-white: rgba(255, 255, 255, 0.2);
    --semi-primary: rgba(29, 27, 40, .2);
    --semi-primary-strong: rgba(29, 27, 40, .66);
    --semi-primary-opac: rgba(29, 27, 40, .95);
    --spacer: 1rem;
    --size-0: 0.125rem;
    --size-1: 0.25rem;
    --size-2: 0.5rem;
    --size-3: 1rem;
    --size-4: 1.5rem;
    --size-5: 2rem;
    --size-6: 3rem;
    --size-7: 5rem;
    --size-8: 8rem;
    --size-9: 12rem;
    --content-width: 60rem;
    --font-family-title: 'Space Mono',monospace,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    --font-family-body: Montserrat,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
    --font-size-xs: .409rem;
    --font-size-sm: .6875rem;
    --font-size-base: .8125rem;
    --font-size-md: 1rem;
    --font-size-lg: 1.25rem;
    --font-size-xl: 1.5rem;
    --font-size-xxl: 2rem;
    --font-size-xxxl: 3.2rem;
    --font-weight-base: 400;
    --font-weight-bold: 700;
    --letter-spacing-sm: 0.05em;
    --letter-spacing-lg: 0.2em;
    --line-height-heading: 1.3;
    --line-height-flow: 1.5;
    --text-light: var(--gray);
    --border-color: var(--gray-700);
    --border-color-dark: var(--primary-dark);
    --border: 1px solid var(--border-color);
    --border-dark: 1px solid var(--border-color-dark);
    --border-thick: 3px;
    --border-radius: var(--size-2);
    --border-radius-sm: var(--size-1);
    --shadow: 0px var(--size-1) var(--size-4) rgba(0, 0, 0, 0.25);
    --shadow-primary: 0px var(--size-1) var(--size-4) var(--semi-primary);
    --shadow-primary-lg: 0px var(--size-2) var(--size-5) var(--semi-primary-strong);
    --shadow-light-lg: 0px var(--size-2) var(--size-5) rgba(255, 255, 255, 0.1);
    --speed: .3s;
    --speed-fast: .15s;
    --speed-slow: .8s;
}

nav button, nav > a {
    display: block;
    margin: 0;
}

a, button {
    text-transform: uppercase;
    font-style:italic;
    font-weight: 700;
    font-size: 1.5rem;
    position: relative;
    z-index: 1;
    text-decoration: none!important;
    color: #FFFFFF!important;
    cursor: pointer;
    font-family: 'Space Mono',monospace,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
}

a>div, button>div {
    display: inline-block;
}

svg.shadow {
    margin-left: -.5rem;
    margin-top: .5rem;
}

svg {
    position: absolute;
    top: -10%;
    left: -10%;
    width: 120%;
    height: 120%;
    z-index: -1;
}

nav>a:last-child, nav>button:last-child {
    margin-right: var(0.25rem);
    transform: rotate(2deg);
    position: absolute!important;
    top: var(1rem);
    right: var(1rem);
}

a:focus svg:not(.shadow),a:hover svg:not(.shadow),button:focus svg:not(.shadow),button:hover svg:not(.shadow) {
    margin-top: .125rem;
    margin-left: -.125rem;
    transform: rotate(9deg)!important
}

a:focus svg.shadow,a:hover svg.shadow,button:focus svg.shadow,button:hover svg.shadow {
    margin-top: .325rem;
    margin-left: -.325rem;
    transform: rotate(-9deg)!important
}

a svg, button svg {
    transition: all .3s;
}

</style>
